"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeGrowAsOne = void 0;
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const Tags_1 = require("../Tags");
const CardRenderer_1 = require("../render/CardRenderer");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const CardRequirements_1 = require("../CardRequirements");
const Card_1 = require("../Card");
const constants_1 = require("../../constants");
const Turmoil_1 = require("../../turmoil/Turmoil");
const TurmoilHandler_1 = require("../../turmoil/TurmoilHandler");
const Size_1 = require("../render/Size");
class WeGrowAsOne extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.WE_GROW_AS_ONE,
            cardType: CardType_1.CardType.EVENT,
            tags: [Tags_1.Tags.SPACE],
            cost: 8,
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.party(PartyName_1.PartyName.UNITY)),
            metadata: {
                description: 'Requires that Unity are ruling or that you have 2 delegates there. ' +
                    'Increase ALL Colony Tile Tracks 1 step. ' +
                    'Increase each Colony Tile Track 1 step if you have a colony on that Colony Tile.',
                cardNumber: 'M59',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.br.br;
                    b.placeColony().any.text('+1').br.br;
                    b.colonies(1).colon().nbsp(Size_1.Size.SMALL).placeColony().text('+1').asterix();
                }),
            },
        });
    }
    ;
    canPlay(player) {
        const turmoil = Turmoil_1.Turmoil.getTurmoil(player.game);
        if (turmoil.parties.find((p) => p.name === PartyName_1.PartyName.UNITY)) {
            return turmoil.canPlay(player, PartyName_1.PartyName.UNITY);
        }
        return player.canAfford(player.getCardCost(this) + constants_1.SOCIETY_ADDITIONAL_CARD_COST);
    }
    play(player) {
        player.game.colonies.forEach((colony) => {
            if (colony.colonies.includes(player.id)) {
                colony.increaseTrack(2);
            }
            else {
                colony.increaseTrack(1);
            }
        });
        TurmoilHandler_1.TurmoilHandler.handleSocietyPayment(player, PartyName_1.PartyName.UNITY);
        return undefined;
    }
}
exports.WeGrowAsOne = WeGrowAsOne;
//# sourceMappingURL=WeGrowAsOne.js.map